import { NewsListWrapper, BtnControl } from "./styled"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import NewsItem from "components/NewsItem"

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    // variableWidth: true,
    slidesToScroll: 4,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

};
function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <BtnControl className={`${className}`} onClick={onClick}><FaAngleRight /></BtnControl>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <BtnControl className={`${className}`} onClick={onClick}>
            <FaAngleLeft />
        </BtnControl>
    );
}


const NewsList = ({ data }) => {
    return (
        <NewsListWrapper>
            <div className="news_list_name">
                <h1 className="s-30 text-black medium">Bài viết mới</h1>
            </div>
            <Slider {...settings}>
                {
                    data?.map((item, index) => (
                        <NewsItem key={index} slug={item.slug} thumbnail={item.thumbnail} name={item.title} date={item.updated_at} />
                    ))
                }
            </Slider>

        </NewsListWrapper>
    )
}

export default NewsList